<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="'Voto #' + this.$route.params.id + ' - ' + getDescTipo(this.$route.params.tipo) + ' #' + this.$route.params.id_scheda">

                    <b-container fluid class="mx-auto text-left" v-if="showdettaglio">
                         <b-row class="my-1">
                                    <b-col sm="3"><label for="coso">Cognome socio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="voto.cognomesocio" id="coso" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="noso">Nome socio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="voto.nomesocio" id="noso" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="maso">Email socio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="voto.accountsocio" id="maso" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="voto">Voto:</label></b-col>
                                    <b-col sm="9">
                                        <div v-if="voto.voto > 0 || (!modifica)">
                                            <star-rating :read-only="modifica" id="voto" v-model="voto.voto" :increment="0.01" :star-size="25" :show-rating="true"></star-rating>
                                        </div>
                                        <div v-else>
                                            Nessuno
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="note">Note:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea :disabled="modifica" id="note" v-model="voto.note" :rows="3"></b-form-textarea>
                                    </b-col>
                                </b-row>
                                <b-row class="my-3">
                                    <b-col sm="6" offset-sm="3">
                                        <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                            <div v-if="modifica">
                                                Modifica
                                            </div>
                                            <div v-else>
                                                Salva
                                            </div>
                                        </b-button>
                                    </b-col>
                                </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

</div>
</template>

<script>

import {
    NAMESPACE
} from '../config.js'

import {
    Categoria,
    Visibilità
} from '../classes.js'

import {
    ctrlVismenu
} from '../util.js'



export default {
    name: 'appdettaglio',
    data: function () {
        return {
                        
            namespace: NAMESPACE,
            voto: {
                id: this.$route.params.id,
                id_scheda: this.$route.params.id_scheda,
                id_socio: null,
                nomesocio: '',
                cognomesocio: '',
                accountsocio: '',
                voto: 0,
                note: ''
            },
            tipo: this.$route.params.tipo,
            error: '',
            showerror: false,
            showdettaglio: false,
            dismissSecs: 2,
            dismissCountDown: 0,
            modifica: true          
        };
    },
    methods: {
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        getDescTipo(tipo) {
            var cat = new Categoria();
            return cat.getTipoByFlag(tipo);
        },
        insert() {

                var appdettaglio = this;

                if (this.modifica) {

                    this.modifica = false;

                } else {

                    var json = JSON.stringify(this.voto);

                    var token = localStorage.getItem('token');
                    this.axios.post(NAMESPACE + 'rest/voto', json, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        })
                        .then(response => {
                            // JSON responses are automatically parsed.
                            try {

                                if (!response.data.error) {

                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                    var res = response.data.message;
                                    if (res.length > 0) {
                                        this.showpassword = false;
                                        this.voto = res[0];
                                        this.showerror = false;
                                        this.showdettaglio = true; //anche se non dovrebbe servire                                 
                                        this.dismissCountDown = this.dismissSecs;
                                        this.modifica = true;

                                        //qui non importa
                                        //this.$router.replace('/app/dettagliovoto/' + this.voto.id);

                                        setTimeout(function() {
                                            //window.history.back();
                                            appdettaglio.$router.go(-1);
                                        }, 2500);

                                    } else {
                                        throw new Error("Errore dati non trovati!");
                                    }


                                } else {
                                    throw new Error(response.data.message);
                                }


                            } catch (e) {
                                appdettaglio.showerror = true;
                                appdettaglio.error = "Errore: " + e.message;
                            }

                        })
                        .catch(e => {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                        });
                }

               

            }


    },
    created: function () {

           
        
            if(!ctrlVismenu("E")&&!ctrlVismenu("N")&&!ctrlVismenu("C")&&!ctrlVismenu("I")){
                this.$router.replace('/accessdenied');
                return;
            }  


            var id = this.voto.id; //se è la prima volta si prova a prendere da getid 

            if (id != null) {

                var token = localStorage.getItem('token');
                var appdettaglio = this;

                this.axios.get(NAMESPACE + 'rest/voto/' + id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.voto = res[0];
                                    this.showdettaglio = true;

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

            

    },
        mounted: function() {
            
          
            
        }

}
</script>
